/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PtwRegistrationState = {
    Unknown: 'Unknown',
    NotRegistered: 'NotRegistered',
    Registered: 'Registered',
    DeRegistered: 'DeRegistered'
} as const;
export type PtwRegistrationState = typeof PtwRegistrationState[keyof typeof PtwRegistrationState];


export function PtwRegistrationStateFromJSON(json: any): PtwRegistrationState {
    return PtwRegistrationStateFromJSONTyped(json, false);
}

export function PtwRegistrationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwRegistrationState {
    return json as PtwRegistrationState;
}

export function PtwRegistrationStateToJSON(value?: PtwRegistrationState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the PtwRegistrationState interface.
 */
 export function instanceOfPtwRegistrationState(value: any): value is PtwRegistrationState {
    return Object.values(PtwRegistrationState).includes(value)
}

